module.exports = __webpack_public_path__ + "static/solution-employee-3d7de7ff2e8aae7da7777213f6069004.png";